import { render } from "./Image.vue?vue&type=template&id=7eb89be8"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"
script.render = render

export default script